<template>
        <div class="col-sm-12 test border-compnenet" v-if="viewPage">
            <div class="form-group p-0-14"  style="" :class="{'custom-field-ibox-content forms-ibox-padding white-bg additional-comments':true}">
                <div class="ibox rotate-div">
                    <div :data-target="`#forms_checklists_toggle_${property[0].customer_property_id}`"
                         @click="collapseAndExtendForm(property[0].customer_property_id)"
                         class="ibox-title"
                         style="border-top: 0px;padding: 8px 0 4px 0;border-radius: 12px !important;cursor: pointer;">
                        <div>
                            <label class="label-form new-design-heading-label">
                                {{property[0].value}}
                                <br/>
                                <span style="font-size: 12px">{{propertyName}}</span>
                            </label>

                            <div class="inline float-right new-design-heading-label">
                                <div class="inline arrow-container float-right" style="margin-left: 10px; margin-top: 10px;">
                                    <a class="" role="button">
                                        <i class="fa fa-chevron-down" style="color: #2E4051" ref="toggleIcon"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :id="`forms_checklists_toggle_${property[0].customer_property_id}`" v-show="collapsed">
                        <div class="col-md-12" style="padding: 0px;">
                            <fieldset class="col-md-12" style="padding: 0px;">
                                <div class="custom-field">
                                    <div  v-for="(propert, index) of property" style="padding: 4px 0px 4px 0px;   color: #2E4051;">
                                        <span style="font-size: 14px;"><b>{{propert.property_field_name}}</b>

                                        </span>: &nbsp
                                        <span style="font-size: 14px;" v-if="propert.type == 9">
                                            <img :src="propert.value" width="20%" />
                                        </span>
                                        <span style="font-size: 14px;" v-if="propert.type == 10">
                                              <div class="toggle-container">
                                                <label class="toggle-label" :for="`toggle_${property[0].customer_property_id}`"></label>
                                                <input ref="toggle" type="checkbox" class="toggle" :id="`toggle_${property[0].customer_property_id}`" :checked="isChecked(propert.value)">
                                                <span class="toggle-new-design"></span>
                                              </div>
                                        </span>
                                        <span v-if="propert.type != 10 && propert.type != 9" >
                                          {{ propert.value }}
                                        </span>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div class="col-md-12"  style="padding: 0px; margin: 10px 0px 0px;">
                            <div class="row"  style="padding: 0px;">
                                <div class="col-md-6 col-xs-6" style="padding-left: 10px;">
                                    <div
                                        @click="deleteProperty(property[0])" style="cursor: pointer;">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_5011_11480)">
                                                <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#F44336"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5011_11480">
                                                    <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xs-6" style="padding-right: 10px;">
                                    <div class="float-right" data-toggle="modal"
                                         :data-target="`#edit_customer_property_${property[0].customer_property_id}_popup`" style="cursor: pointer;">
                                        <svg data-v-42abf014="" width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-42abf014="" d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <customer-property-edit-popup :id="`edit_customer_property_${property[0].customer_property_id}_popup`"
                                                  :country-code="countryCode"
                                                  :date-format="dateFormat"
                                                  :property-name="property[0].value"
                                                  :property-id="property[0].property_id"
                                                  :customer-id="customerId"
                                                  :customer-property-id="property[0].customer_property_id"
                                                  :country-key="countryKey"
                    >
                    </customer-property-edit-popup>
                </div>
            </div>
        </div>
        <div class="row customer-property-item" v-else>
                <div class="col-md-12">
                    <div class="d-inline">
                        <span class="property-value">{{ property.value | escapeSpecialCharacters}}</span><br/>
                        <span class="property-name">{{ propertyName }}</span>
                    </div>
                    <div class="d-inline customer-property-item-icon clickable" data-toggle="modal"
                         :data-target="`#edit_customer_property_${property.customer_property_id}_popup`">
                        <svg width="19" height="18" viewBox="0 0 19 18"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
                                fill="#03A9F4"/>
                        </svg>
                    </div>
                    <div class="d-inline clickable customer-property-item-icon margin-right-20"
                         @click="deleteProperty(property)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                                fill="#03A9F4"/>
                        </svg>

                    </div>

                    <customer-property-edit-popup :id="`edit_customer_property_${property.customer_property_id}_popup`"
                                                  :country-code="countryCode"
                                                  :date-format="dateFormat"
                                                  :property-name="property.value"
                                                  :property-id="property.property_id"
                                                  :customer-id="customerId"
                                                  :customer-property-id="property.customer_property_id"
                                                  :country-key="countryKey"></customer-property-edit-popup>
                </div>
                <div class="col-md-12">
                    <hr style="color:#E0E2E5;">
                </div>
        </div>

</template>

<script>
import {getCustomerProperty} from '@/modules/CustomerProperties/api';
import {EventBus} from "@/events/event-bus";


export default {
    name: "CustomerPropertyItem",
    props: {
        property: {
            required: true
        },
    propertyName: {
      required: true
    },
        countryCode: {
            required: true
        },
        countryKey: {
            required: true
        },
        dateFormat: {
            required: true
        },
        customerId: {
            required: true
        },
        collapsed:false,
        viewPage:false,
    },
    methods: {
    deleteProperty(property) {
      EventBus.$emit('onCustomerPropertyDeleted', property)
        },
        addEventListeners() {
        EventBus.$on('onCustomerPropertyUpdated', data => {
            if(this.viewPage){
                if(this.property[0].customer_property_id == data.customer_property_id){
                    getCustomerProperty(data.customer_property_id, data.property_id, 1).then(response => {
                        if(this.property[0].customer_property_id == response.data[0].customer_property_id){
                            this.property = response.data;
                            this.$forceUpdate()
                        }
                    });
                }
            }else{
                if (this.property.customer_property_id == data.customer_property_id) {
                    this.property.value = data.customer_primary_field_vlaue
                    this.$forceUpdate()
                }
            }

        })
        },
        collapseAndExtendForm(id) {
            if(this.collapsed){
                this.expandForm(id);

            } else{
                this.collapseForm(id);
            }
            this.$forceUpdate()
        },
        collapseForm(id) {
            this.collapsed = true;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

            // EventBus.$emit('onChangeCheckListStatus',this.form.form_id , true);
        },
        expandForm(id) {
            this.collapsed = false;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

            // EventBus.$emit('onChangeCheckListStatus',this.form.form_id , false);
        },
        isChecked(checkStatus){
            if(checkStatus == 'false'){
                return false;
            }
            return checkStatus;
        }
    },
    filters: {
        escapeSpecialCharacters: function (value) {
            if (!value) return ''
             let decoded = value.replace(/&amp;/g, '&');
             return decoded
        }
    },
    mounted() {
        this.addEventListeners()
    }
}
</script>

<style scoped>
.margin-right-20 {
    margin-right: 20px;
}

.clickable {
    cursor: pointer;
}

.property-name {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #979FA8;
}

.property-value {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #2E4051;
    display: inline-block;
    max-width: 500px;
}

.customer-property-item-icon {
    float: right;
    position: relative;
    bottom: 10px;
    display: inline
}

.d-inline {
    display: inline;
}

@media (max-width: 750px) {
    .property-value {
        max-width: 229px;
    }

    .label-form{
        max-width: 75%;
    }
}
.border-compnenet{
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    margin-bottom: 2%;
}
.new-design-heading-label {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #2E4051;
}
.ibox {
    clear: both;
    margin-bottom: 0px;
    margin-top: 0;
    padding: 0;
}
.ibox-title{
    border-top: 0px;
    padding: 14px 15px 0px;
    border-radius: 12px !important;
    cursor: pointer;
}
.form-group {
    margin-bottom: 0px;
}



.toggle-label {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #2E4051;
    top: -3px;
    position: relative;
}

.toggle-container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.toggle {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}


.toggle-container {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 34px;
    bottom: 5px;
}

.toggle {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-new-design {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
}

.toggle-new-design:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

.toggle:checked ~ .toggle-new-design {
    background-color: #2E4051;
}

.toggle:focus ~ .toggle-new-design {
    box-shadow: 0 0 1px #E0E2E5;
}

.toggle:checked ~ .toggle-new-design:before {
    transform: translateX(26px);
}
</style>